/* eslint-disable class-methods-use-this, @typescript-eslint/no-empty-function */
var ClientRenderDetailsController = /** @class */ (function () {
    function ClientRenderDetailsController() {
    }
    ClientRenderDetailsController.prototype.setRedirectUrl = function () { };
    ClientRenderDetailsController.prototype.setNavConfig = function () { };
    ClientRenderDetailsController.prototype.setPageError = function () { };
    return ClientRenderDetailsController;
}());
export { ClientRenderDetailsController };
